'use client';
import styled from 'styled-components';

export const StyledVideoModal = styled.div`
  width: 95vw;
  @media ${props => props.theme.laptop} {
    height: 95vh;
    width: auto;
    max-width: 95vw;
    aspect-ratio: ${props => props.aspectRatio};
  }
`;
